<template>
  <!-- 月总体课消数 -->
  <div class="MonthOverallNum">
    <p style="height: 30px;"><span @click="goBack" class="el-icon-circle-close"
        style="float: right; font-size: 24px;"></span></p>
    <div id="MonthOverallNum" style="width: 100%; height: 400px;"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import axios from "axios";
import apiBaseUrl from "../../../config/api";
export default {
  data () {
    const stashStrs = localStorage.getItem('setStash')
    const stashs = stashStrs ? JSON.parse(stashStrs) : {}
    return Object.assign({
      text: '',
      dataList: []
    }, stashs)
  },
  created () {
    // this.text = this.$route.query.timeText
    // this.dataList = this.$route.query.data
  },
  mounted () {
    let Obj = localStorage.getItem('dataStr')
    let ObjStr = JSON.parse(Obj)
    this.text = ObjStr.timeText
    this.dataList = ObjStr.data
    this.getMonthOverallNum()
  },
  methods: {
    //关闭按钮
    goBack () {
      history.go(-1)
    },
    getMonthOverallNum () {
      let chartDom = document.getElementById('MonthOverallNum');
      let myChart = echarts.init(chartDom);
      let option;

      option = {
        color: ['#5087ec'],
        tooltip: {
          trigger: 'axis'
        },
        title: {
          text: this.text + '月总课消',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: this.dataList.map(item => item.nameOrMonth)
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.dataList.map(item => item.num),
            type: 'bar'
          }
        ]
      };

      option && myChart.setOption(option);
      window.onresize = function () {
        myChart.resize();
      }
      myChart.setOption(option);
      myChart.off('click'); //防止触发两次点击事件
      myChart.getZr().on('click', (params) => {
        localStorage.setItem('setStash', JSON.stringify(this.$data))
        let pointInPixel = [params.offsetX, params.offsetY];
        if (myChart.containPixel('grid', pointInPixel)) {
          let pointInGrid = myChart.convertFromPixel({
            seriesIndex: 0
          }, pointInPixel);
          let xIndex = pointInGrid[0]; //索引
          let handleIndex = Number(xIndex);
          // console.log(handleIndex);
          let seriesObj = myChart.getOption(); //图表object对象
          var op = myChart.getOption();
          // 获得图表中点击的列
          var month = op.xAxis[0].data[handleIndex];  //获取点击的列名
          // console.log(this.text + '' + "-" + month);
          // console.log(month);
          // console.log(handleIndex);
          // console.log(this.topArr[handleIndex].curve);
          // const data=this.topArr[handleIndex]
          localStorage.setItem('ownerDate', (this.text + '' + "-" + month))
          this.$router.push({
            path: '/DayOverallNum',
          })
        };
      });
    },
  }
}
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .MonthOverallNum {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.MonthOverallNum {
    width: 100% !important;
  }

}</style>



// WEBPACK FOOTER //
// src/manager/components/MonthOverallNum.vue